import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import Grid from '../../components/Grid.js';
import Title from '../../components/Title.js';
import PagingBar from '../../components/PagingBar.js';
import IconUser from '../../components/icons/IconUser.js';
import ApiService from '../../services/ApiService.js';
import { getWords } from '../../utils/get-words.js';
import { protect } from '../../utils/protect.js';

const UsersMonitorLeft2 = ReactRouterDOM.withRouter(function ({ branch, user, setUser }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);
  const [count, setCount] = React.useState(null);
  const [pageNumber, setPageNumber] = React.useState(1);
  const pageSize = 10;
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    setPageNumber(1);
    loadCount();
  }, [branch]);

  React.useEffect(() => {
    loadRecords();
  }, [pageNumber, branch]);

  const loadCount = async function () {
    try {
      const args = {};
      if (branch.branchId !== null && branch.branchId !== undefined) {
        args.branchBranchId = branch.branchId;
      }
      setCount(await ApiService.getCountUsers(args));
    }
    catch (error) {
      setError(error);
      return;
    }
  }
  
  const loadRecords = async function () {
    let records = null;
    try {
      const args = {};
      if (branch.branchId !== null && branch.branchId !== undefined) {
        args.branchBranchId = branch.branchId;
      }
      args.offset = (pageNumber - 1) * pageSize;
      args.limit = pageSize;
      records = await ApiService.getUsersV2(args);
    }
    catch (error) {
      setError(error);
      return;
    }
    setItems(records.map((record, index) => ({
      key: record.userId,
      data: [
        protect(function ([firstName, lastName]) { return `${firstName} ${lastName}` }, [ record.firstName, record.lastName ]),
        record.status,
      ],
      record: record
    })));
    if (records.length > 0) {
      setUser(records[0]);
    }
  }
  
  const refreshMe = async function () {
    await loadCount();
    await loadRecords();
  }
  
  const handleClickItem = async function (e, item) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    setUser(item.record);
  }
  
  return (
    <div>
      <div>
        <div className="pb-1 d-flex align-items-center border-bottom">
          <Title level={1} icon={IconUser} color="blue" label={words.officers} />
          <div className="flex-grow-1" />
        </div>
        <Grid
          contextualActions={[
          ]}
          fields={[
            {
              icon: IconUser,
              label: words.name,
              type: 'string',
              bindIndex: 0,
            },
            {
              label: words.status,
              type: 'string',
              translate: true,
              variant: 'framed-text',
              color: function (value) { return value === 'inRevision' ? 'red' : (value === 'confirmed' ? 'yellow' : (value === 'sent' ? 'green' : 'black')); },
              alignment: 'center',
              bindIndex: 1,
            },
          ]}
          onClickItem={handleClickItem}
          selectedKey={user ? user.userId : null}
          items={items}
        />
        {count !== null && count !== undefined ?
          <PagingBar
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            countOfItems={count}
            countOfPages={Math.ceil(count/pageSize)}
          /> :
          null
        }
      </div>
    </div>
  );
})

export default UsersMonitorLeft2;
